// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"97c2cf36","292":"3eb09207"}[chunkId] + ".chunk.js";
};